import { Translations } from '../../types/i18n';

export const en: Translations = {
  welcome: {
    title: 'Welcome',
    subtitle: 'Would you please tell me your name?',
    description: "It's not necessary but it will make a better experience!",
    nameLabel: 'Name',
    namePlaceholder: 'Type your name here...',
    submitButton: 'This is my name!',
    skipButton: "I'd rather not...",
    cookieNotice: 'By continuing, you accept the use of cookies to improve the user experience.',
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
  },
  navigation: {
    home: 'Home',
    about: 'About',
    work: 'Work',
    portfolio: 'Portfolio',
    contact: 'Contact',
    games: 'Games',
  },
  avatar: {
    chooseOption: 'Choose an option',
    actions: {
      sayHi: 'Say Hi',
      meow: 'Meow!',
      playGames: 'Play Games',
      leave: 'Leave',
      doingFine: "I'm doing fine, thanks.",
      talkWork: "Let's talk about work!",
      tellMore: 'Tell me more about yourself',
      howContact: 'How can I contact you?',
      hearJoke: 'I wanna hear a joke!',
      randomFact: 'Gimme a random fact!',
      seePortfolio: 'Can I see your portfolio?',
      somethingInteresting: 'Tell me something interesting!',
      showPortfolio: 'Show me your portfolio!',
      letsPlayGames: "Let's play some games!",
      freeChat: 'Free Chat',
    },
    dialogues: {
      greeting: 'Hello, fellow traveler of the interwebz!',
      greetingWithName: 'Hello, {name}!',
      howAreYou: 'How are you doing today? Can I help you with anything? :)',
      howAreYouWithName: 'How are you doing today, {name}? Can I help you with anything? :)',
      goodbye: 'Well... Goodbye!',
      likeCats: 'So, you like cats? These are Ralph and Atreyu',
      gladFine: "I'm really glad you're doing fine. :)",
      readAboutMe: 'Sure, you can read more about me in the browser window! :)',
      lookAtBrowser: 'Sure, take a look at the browser window.',
      contactLinks:
        'You can reach me through any of the links at the top. Or you can also drop me a line in the contact form in the browser window!',
      projectsWorkedOn: "These are some of the projects I've worked on recently.",
      letsPlayGames: "Awesome! Let's play some games! You can find them in the navigation bar.",
      dontPoke: "Please don't poke me!",
      dontPokeWithName: "Please don't poke me, {name}!",
      notFunLeaving: "Ok, this is not fun, I'm leaving.",
      freeChatIntro: "Cool, you wanna chat freely? Ask me anything! Type away! :)",
      freeChatError: "Hmm, something went wrong. Try again!",
      freeChatExit: "That was fun! What else would you like to do?",
      radioPlay: "That's my music! You can find more on my SoundCloud. Check the links above! :)",
    },
    chat: {
      placeholder: 'Type a message...',
      send: 'Send',
      exit: 'Exit Chat',
      thinking: 'Thinking...',
    },
    fallbackJokes: [
      "Why don't scientists trust atoms? Because they make up everything!",
      'Why did the scarecrow win an award? He was outstanding in his field!',
      "Why don't eggs tell jokes? They'd crack up!",
      'What do you call a fake noodle? An impasta!',
      'Why did the coffee file a police report? It got mugged!',
    ],
    fallbackFacts: [
      'Honey never spoils. Archaeologists have found pots of honey in ancient Egyptian tombs that are over 3,000 years old!',
      "A group of flamingos is called a 'flamboyance'.",
      "Bananas are berries, but strawberries aren't!",
      'The shortest war in history lasted only 38 minutes.',
      'Octopuses have three hearts and blue blood!',
    ],
  },
  home: {
    title: 'Welcome to my Website!',
    welcomeText: "I'm Maw, a Senior Full-Stack Developer.",
    exploreText:
      'Explore my work, check out my portfolio, or get in touch using the navigation above!',
    tipsText:
      "💡 This isn't just a website — it's a whole browser! Switch the language 🌐 or day/night mode ☀️🌙 from the Edit menu (or the status bar below), pick a browser theme 🎨 in the View menu, change your name in the File menu, and open Help for keyboard shortcuts.",
    quickLinks: 'Quick Links',
    viewPortfolio: 'View Portfolio',
    downloadResume: 'Download Resume',
    contactMe: 'Contact Me',
    visitorNumber: 'You are visitor #{number}',
    bestViewed: 'Best viewed in Netscape Navigator 4.0 at 800x600',
    checkOutProjects: 'Check out my latest projects!',
    loveToHear: "I'd love to hear from you!",
  },
  about: {
    title: 'About Me',
    role: 'Senior Full-Stack Developer & Technical Lead',
    welcomeText:
      "Welcome to my corner of the web! I'm a Computer Science graduate with over 15 years of experience in web development (since 2009).",
    specializeText:
      'I specialize in building scalable applications and leading technical teams. My expertise spans modern JavaScript/TypeScript ecosystems, cloud infrastructure, and emerging Web3 technologies.',
    deliveredText:
      "Throughout my career, I've delivered solutions for clients ranging from startups to enterprises across fintech, e-commerce, and Web3 sectors.",
    downloadResume: 'Download My Resume',
    keySkills: 'Key Skills',
    visitorNumber: 'You are visitor #{number}',
    experienceText: '',
  },
  work: {
    title: 'Tech Stack',
    categoryDescriptions: {
      all: "With 15+ years in web development, I've mastered a comprehensive tech stack.",
      frontend:
        '10+ years crafting responsive, performant UIs with modern frameworks and best practices.',
      backendData:
        'Building scalable APIs, microservices, and data architectures with SQL, NoSQL, and blockchain since 2012.',
      platforms:
        'Deploying and managing applications across CMS platforms, cloud infrastructure, and hosting.',
      tools: 'Streamlining development workflows with cutting-edge tooling, CI/CD, design, and automation.',
    },
    categories: {
      all: 'All',
      frontend: 'Frontend',
      backendData: 'Backend & Data',
      platforms: 'Platforms',
      tools: 'Tooling',
    },
    viewProjects: 'View My Projects',
    followOnGithub: 'Follow my latest experiments on',
    totalDownloads: 'Total Downloads: {count}',
    showTechnologies: "Let me show you what I've built with these technologies!",
  },
  portfolio: {
    title: 'Portfolio',
    clickToView: 'Click images to view live demos!',
    loadingProjects: 'Loading projects...',
    noProjects: 'No projects available at the moment.',
    featuredProject: 'Featured Project: {name}',
    visitProject: 'Visit Project',
    getInTouch: 'Get In Touch',
    projectsAvailable: '{count} Projects Available',
    loveToHear: "I'd love to hear from you!",
    categories: {
      all: 'All',
      professional: 'Professional',
      web3: 'Web3',
      experiments: 'Experiments',
    },
  },
  contact: {
    title: 'Contact Me!',
    subtitle: "Feel free to leave a message. I'll get back to you as soon as possible!",
    nameLabel: 'Name:',
    namePlaceholder: 'Your name',
    emailLabel: 'Email:',
    emailPlaceholder: 'your@email.com',
    messageLabel: 'Message:',
    messagePlaceholder: 'Type your message here...',
    sendButton: 'Send Message',
    sending: 'Sending...',
    successMessage: 'Message sent successfully.',
    visitorsSigned: '{count} visitors signed!',
  },
  browser: {
    menus: {
      file: 'File',
      edit: 'Edit',
      view: 'View',
      favorites: 'Favorites',
      themes: 'Themes',
      help: 'Help',
    },
    themes: {
      classic: 'Classic',
      vaporwave: 'Vaporwave',
      terminal: 'Terminal',
      notebook: 'Notebook',
    },
    titles: {
      home: 'Welcome to Maw.dev - Web Explorer',
      about: 'About Me - Web Explorer',
      work: 'Tech Stack - Web Explorer',
      portfolio: 'Portfolio Gallery - Web Explorer',
      contact: 'Contact Form - Web Explorer',
      games: 'Games - Web Explorer',
    },
    bsod: {
      title: ':(',
      mainText: 'Your PC ran into a problem and needs to restart.',
      collectingError: "We're just collecting some error info, and then we'll restart for you.",
      errorCode: 'CRITICAL_PROCESS_DIED',
      stopCode: 'Stop code: 0x000000EF',
      clickToRestart: 'Click anywhere to restart...',
    },
    statusDone: 'Done',
    statusZone: 'Internet',
    settings: {
      title: 'Settings',
      language: 'Language',
      mode: 'Mode',
      theme: 'Theme',
      dayMode: 'Day Mode',
      nightMode: 'Night Mode',
      changeName: 'Change Name...',
      showWelcome: 'Show Welcome Screen',
    },
    help: {
      title: 'Help',
      navigation:
        'Use the menu bar or page navigation tabs to explore different sections of this site.',
      sections: 'Sections: Home, About Me, Tech Stack, Portfolio, Contact, and Games.',
      themes: 'Change the visual theme under View, or toggle Day/Night mode in Edit.',
      contact: 'Reach me via the Contact page or find me on GitHub.',
      easterEggs: 'Try clicking around — there might be surprises!',
      ok: 'OK',
    },
    favorites: {
      linkedin: 'LinkedIn',
      github: 'GitHub',
      soundcloud: 'SoundCloud',
    },
    pause: {
      title: 'Paused',
      hint: 'Click anywhere to resume',
    },
  },
  games: {
    title: 'Games',
    subtitle: 'Select a game to start playing',
    racing: {
      title: 'Racing',
      description: '3D Speed',
      startRacing: 'Start Racing!',
      useKeyboard: 'Use keyboard to race!',
      useTouchControls: 'Use touch controls to race!',
      turnLeft: 'Turn left',
      turnRight: 'Turn right',
      accelerate: 'Accelerate',
      brake: 'Brake',
      collectCoins: 'Collect coins and avoid crashing into other cars!',
      pressEscContinue: 'Press ESC to continue',
      or: 'or',
    },
    tetris: {
      title: 'Tetris',
      description: 'Classic Puzzle',
    },
    snake: {
      title: 'Snake',
      description: 'Eat & Grow',
    },
    flappyBird: {
      title: 'Flappy Bird',
      description: 'Fly High',
    },
    breakout: {
      title: 'Breakout',
      description: 'Break Bricks',
    },
    penaltyShootout: {
      title: 'Penalty',
      description: 'Score Goals',
    },
    candyCrush: {
      title: 'Candy Crush',
      description: 'Match Candy',
    },
    rhythmHighway: {
      title: 'Rhythm Highway',
      description: 'Hit the Beat',
    },
    pacMan: {
      title: 'Pac-Man',
      description: 'Eat Dots',
    },
    soccerJuggling: {
      title: 'Juggling',
      description: 'Keep It Up',
    },
    congratulations: 'Congratulations!',
    sorry: 'Sorry!',
    wonPoints: 'You won {points} points',
    tryAgain: 'Try again',
    backToMenu: 'Back to Games Menu',
    readyToPlay: 'READY TO PLAY',
    pause: 'PAUSE',
    gameOver: 'GAME OVER',
    levelComplete: 'LEVEL COMPLETE!',
    finalScore: 'Final Score',
    level: 'Level',
    pressSpaceToStart: 'PRESS SPACE TO START',
    continue: 'Continue',
    quit: 'Quit',
    leaderboard: 'Leaderboard',
    enterName: 'Enter your name',
    saveScore: 'Save Score',
    skip: 'Skip',
    noScoresYet: 'No scores yet. Be the first!',
    newHighScore: 'New High Score!',
  },
};
